import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import {MsAuthService} from './service';

@Injectable({
    providedIn: 'root'
})
export class MsAuthGuard  {
    private router = inject(Router);
    private msAuthService = inject(MsAuthService);


    async canActivate(): Promise<boolean> {
        await this.msAuthService.isReady();

        if (this.msAuthService.isAuthenticated()) {
            return true;
        } else {
            await this.msAuthService.redirectWhenNoAuthentication();

            return false;
        }
    }

    async canActivateChild(): Promise<boolean> {
        return this.canActivate();
    }

}
